import React from 'react';
import {dsnCN} from "../../hooks/helper";


function Social({className, ...restProps}) {
    const paginate = [
        {link: "https://www.facebook.com/devlift", title: "Facebook"},
        {link: "https://www.instagram.com/devlift.media/?hl=en", title: "Instagram"},
        {link: "https:///linkedin.com/company/devliftmedia/", title: "Linkedin"},
    ];
    return (
        <ul className={dsnCN('col-menu', className)} {...restProps}>
            {
                paginate.map(
                    (item, i) =>
                        <li key={i}> <a href={item.link} target="_blank" rel="nofollow noopener noreferrer" style={{position:'relative', bottom:'5px'}}>{item.title}</a></li>
                )
            }
        </ul>
    );
}

export default Social;
